import React from 'react';

const Input = ({ name, label, value, options, handleChange, error }) => {
  return (
    <div className='form-group'>
      <label htmlFor={name}>{label}</label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        className='form-control'
      >
        <option value='' />
        {options.map((s) => (
          <option key={s._id} value={s._id}>
            {s.name}
          </option>
        ))}
      </select>
      {error && <div className='alert alert-danger'>{error}</div>}
    </div>
  );
};

export default Input;
